export enum Direction {
  'INITIAL' = 'initial',

  'PERSONAL_DETAILS' = 'personal-details',
  'SELECT_ADDRESS' = 'select-address',
  'SELECT_RESCHEDULE_REASON' = 'select-reschedule-reason',
  'SELECT_DIAGNOSIS' = 'select-diagnosis',
  'SELECT_MEDIUM' = 'select-medium',
  'SELECT_CITY' = 'select-city',
  'SELECT_CLINIC' = 'select-clinic',
  'SELECT_LANGUAGE' = 'select-language',
  'SELECT_SLOT' = 'select-time',
  'CHECKOUT' = 'checkout',
  'CONFIRM_BOOKING' = 'confirm',
  'SELECT_LAB_SLOT' = 'select-lab-slot',
  'QUESTIONNAIRE' = 'questionnaire',
  'TAKE_ASSESSMENT' = 'take-assessment',
}
